import { GatsbyImage, getImage, ImageDataLike } from 'gatsby-plugin-image';
import React from 'react';
import { Eyebrow } from '../Eyebrow/Eyebrow';
import cn from 'classnames';
import './HeroImage.scss';

export interface HeroImageInputs {
    imageAlt: string;
    heroText?: string;
    heroTitle?: string;
    hideHero?: boolean;
    eyebrowText?: string;
    image: ImageDataLike;
    homepage?: boolean;
    policy?: boolean;
    hideArrows?: boolean;
    url?: boolean;
    h2?: boolean;
    leadershipPage?: boolean;
}

export const HeroImage = ({ inputs }: { inputs: HeroImageInputs }) => {
    const gImage = inputs.image ? getImage(inputs.image) : undefined;

    return (
        <>
            {!inputs.hideHero && gImage && (
                <div
                    className={`image-holder ${
                        inputs.homepage ? `homepage` : `kite-container`
                    } ${inputs.hideArrows ? `no-arrows` : ``}`}
                >
                    <GatsbyImage
                        className={`hero__image ${
                            inputs.homepage ? `homepage` : `kite-container`
                        }`}
                        alt={inputs.imageAlt ? inputs.imageAlt : ``}
                        image={gImage}
                        loading="eager"
                    />
                </div>
            )}
            {(inputs.heroTitle || inputs.heroText) && !inputs.hideHero && (
                <section
                    className={cn(`hero__text`, {
                        homepage: inputs.homepage,
                        'kite-container': !inputs.homepage,
                        policy: inputs.policy,
                        link: inputs.url,
                        leaders: inputs.leadershipPage,
                    })}
                >
                    {inputs.eyebrowText && (
                        <Eyebrow text={inputs.eyebrowText} bg="light" />
                    )}
                    {!inputs.h2 && <h1>{inputs.heroTitle}</h1>}
                    {inputs.h2 && <h2>{inputs.heroTitle}</h2>}
                    {inputs.heroText && (
                        <div
                            className="content"
                            dangerouslySetInnerHTML={{
                                __html: inputs.heroText,
                            }}
                        />
                    )}
                </section>
            )}
        </>
    );
};
